import apiClient from './apiClient';

export const documentsAPI = {
  upload: (formData) => apiClient.post('/documents/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  list: (params) => apiClient.get('/documents/', { params }),
  delete: (id) => apiClient.delete(`/documents/${id}/`),
  getPreviewUrl: (id) => {
    const baseUrl = apiClient.defaults.baseURL || '';
    return `${baseUrl}/documents/${id}/preview/`;
  },
  getDownloadUrl: (id) => {
    const baseUrl = apiClient.defaults.baseURL || '';
    return `${baseUrl}/documents/${id}/download/`;
  },
};
